const initialstate = {
  data:[],
  docview:[],
  deletedata:[],
  adddocdata:[],
  imagedata:[],
  editdata:[],
  
  
};

const OrgDocumentsReducers =  (state = initialstate, action:any)=>{
  switch (action.type){
      case 'fetch_data_success':
          return {... state, data:action.payload};
          case 'fetch_view_data_success':
          return {... state, docview:action.payload};
          case 'fetch_delete_data_success':
          return {... state, deletedata:action.payload};
          case 'fetch_add_data_success':
          return {... state, adddocdata:action.payload};
          case 'fetch_add_data_success_file':
          return {... state, imagedata:action.payload};
          case 'fetch_edit_data_success_':
          return {... state, editdata:action.payload};
                     default :
          return state;
  }
};
export default OrgDocumentsReducers;